module.exports = __webpack_public_path__ + "img/fisio.aa82df29.png";